import React, {useEffect, useState} from "react";
import {Alert, Button, Col, Form, Input, Modal, Row, Space, Typography} from "antd";
import useVerifyUserMobileCode, {VerifyOutput} from "./useVerifyUserMobileCode";
import useVerifyUserMobileNumber from "./useVerifyUserMobileNumber";
import {isErrorException} from "@firefly/fly-http";
import OTP from "../../component/OTP";


export interface VerifyUserMobileNumberModalProps {
    top?: string | number;
    open: boolean;
    userid: string;
    mobile: string;
    onOk?: (output: VerifyOutput) => void | Promise<void>;
    onCancel?: () => void;
    destroyOnClose?: boolean;
}

//eyJhbGciOiJSUzI1NiJ9.eyJtb2JpbGUiOiIxNTM3NTcxNzEzMCIsImlzcyI6MTcxNzY0NjY4OTc3MSwidmVyaWZ5LW1vZGUiOiJDT0RFIiwiZXhwIjoxNzE3NjQ3Mjg5NzcxfQ.Jho3t0Ybh5dMv6rVGPErKre8BaJf2-3cq9QsYZH5Onqhce06A0d_HbQHMRE_P7bHsu62EZqcWw36HImQMWYgT-EIwQLqS0aLU2JSUD63mMyS4GD9AsqFJnyUyh-wsQsMi16w7ztpXUpX2H4nSP7HiQjUYgEekQI6YSdtUajwPiIOoKuVYXIrG9HCoNSvQDiTnu58-6Nsr1iRpnMMlRFkf77C41s0zWcJKcUj0TuJhuuN8KravePRzT1yXgynMpybHRTu-aam539_RV4CUkcG7W7ZfnWyOcGkCb8bCMKBO2G_gv-XsH0s9MbZGKwhYyjmf4Sqo24VCRmG4EIASRC2mw
function VerifyUserMobileNumberModal(props: VerifyUserMobileNumberModalProps) {
    const {
        top = 10,
        open,
        userid,
        mobile,
        onOk,
        onCancel,
        destroyOnClose,
    } = props;

    const [error, setError] = useState<string | null>(null);
    const {
        isVerifyLoading,
        verify,
        verifyError,
    } = useVerifyUserMobileNumber(userid);

    return <>
        <Modal
            style={{
                top: top
            }}
            title={"身份验证"}
            open={open}
            cancelText={"取消"} okText={"确认"}
            footer={false}
            onCancel={onCancel}
            destroyOnClose={destroyOnClose}
            // width={580}
            // styles={{
            //     body: {
            //         // padding: 20
            //     }
            // }}
        >

            <Space direction={"vertical"} style={{
                alignItems: "center",
                width: "100%",
            }}>
                <div style={{marginBottom: 20}}>
                    <Typography.Text type={"secondary"}>补齐安全手机号进行身份认证</Typography.Text>
                </div>
                <Form
                    layout={"vertical"}
                    // labelCol={{
                    //     span: 4
                    // }}
                    onFinish={(values) => {
                        setError(null)
                        const number = mobile.replace(/\*+/, values.supplement);
                        verify({
                            number: number,
                        }).then((value) => {
                            onOk?.({
                                token: value.token
                            })
                        }, (reason) => {
                            if (isErrorException(reason)) {
                                const error = reason.error;
                                if (error.code === 'WANGAME_ERR_MOBILE_VERIFY_WRONG') {
                                    setError("验证失败");
                                } else {
                                    setError(reason.message);
                                }
                            } else {
                                setError(reason.message);
                            }
                        })
                    }}
                >

                    <Form.Item className={"verify-mobile-item"}>
                        <div className={"mobile-mask"} style={{marginRight: 8}}>
                            <OTP
                                rootClassName={"test"}
                                className={"left"}
                                formatter={(str) => mobile.substring(0, 3)}
                                length={3}
                                // status={"error"}
                                variant={"borderless"}
                            />
                        </div>
                        <Form.Item name={"supplement"} noStyle>
                            <OTP
                                className={"value"}
                                formatter={(str) => str.toUpperCase()}
                                length={4}
                                // status={"error"}
                                variant={"filled"}
                            />
                        </Form.Item>
                        <div className={"mobile-mask"} style={{marginLeft: 8}}>
                            <OTP
                                formatter={(str) => mobile.substring(7)}
                                length={4}
                                // status={"error"}
                                variant={"borderless"}
                            />
                        </div>
                    </Form.Item>


                    <Form.Item wrapperCol={{offset: 8, span: 16}}>
                        <Space>
                            <Button htmlType="button" onClick={() => {
                                onCancel?.();
                            }}>
                                取消
                            </Button>
                            <Button loading={isVerifyLoading} disabled={isVerifyLoading} type="primary"
                                    htmlType="submit">
                                确认
                            </Button>

                        </Space>
                    </Form.Item>
                </Form>
                {error ? <Alert style={{
                    marginBottom: 20
                }} message={error} type="error" showIcon/> : null}
            </Space>
        </Modal>
    </>
}

export default VerifyUserMobileNumberModal;